import React from "react";

import { Br } from "components/br";

import DownloadAndLogIn from "gifs/download-and-log-in.gif";
import GoToPayViaQR from "gifs/go-to-pay-via-qr.gif";
import ScanYouQR from "gifs/scan-your-qr.gif";

import WinOnReferrals from "svgs/drivers/win-on-referrals.svg";
import EaseOfUseIcon from "svgs/drivers/ease-of-use.svg";
import RewardsIcon from "svgs/drivers/rewards.svg";
import SpeedIcon from "svgs/drivers/speed.svg";

export const testimonialsSection = {
  title: (
    <>
      Join 5,000+ drivers to earn more <Br on="desktop" /> with the Nomba app
    </>
  ),
  description:
    "See why thousands of Uber, Bolt, InDrive drivers make extra money by simply driving, referring and earning using the Nomba app.",
  testimonials: [
    {
      testimony: `"Since I start to use Nomba app, my transfer dey go sharp sharp. No more wahala with delay. I fit see my money correct correct. Plus, when I invite my padi them, I dey earn something join. E sweet well well!`,
      driverName: "Kolade",
      driverCompany: "Uber Driver",
    },
    {
      testimony: `"Nomba app don make my life easier as a Bolt driver. Transfers are instant and I get confirmation immediately.
        No stress at all. And I even earn more money by inviting my friends and passengers to use Nomba.`,
      driverName: "Mr Godwin",
      driverCompany: "Bolt Driver",
    },
    {
      testimony: `“Before, e dey hard to get my transfer quick, but Nomba change everything. Now I fit get my alert fast fast and confirm am. I don dey invite my passengers to use Nomba and I dey make extra cash.`,
      driverName: "Charity Nnamdi",
      driverCompany: "InDrive Driver",
    },
    {
      testimony: `“As an Uber driver, Nomba has been a game changer for me. Transfers are super fast and I get instant confirmation. Plus, earning extra by inviting others is a great bonus. I'm loving it!`,
      driverName: "Kazeem",
      driverCompany: "Lagos Ride Driver",
    },
    {
      testimony: `“Nomba don make my work easy. Transfers dey quick, and I no dey worry about whether the money don enter. I invite my customers and other drivers to join, and I dey earn small change from there. Nomba na better app.`,
      driverName: "Collins",
      driverCompany: "Uber Driver",
    },
  ],
};

export const howItWorksSection = {
  title: (
    <>
      How does Nomba <Br /> QR work?
    </>
  ),
  cardsData: [
    {
      instruction: (
        <>
          Download and sign up or <Br /> log in to Nomba app
        </>
      ),
      graphic: (
        <img
          src={DownloadAndLogIn}
          alt="An illustration of Nomba QR onboarding"
          className="max-w-[200px]"
        />
      ),
    },
    {
      instruction: (
        <>
          Go to "Pay via QR" and <Br /> tap on "My QR code"
        </>
      ),
      graphic: (
        <img
          src={GoToPayViaQR}
          alt="An illustration of a driver navigating to the QR code section of the Nomba app"
          className="max-w-[200px]"
        />
      ),
    },
    {
      instruction: (
        <>
          Customers scan your QR, <Br /> and complete payment
        </>
      ),
      graphic: (
        <img
          src={ScanYouQR}
          alt="An illustration of a customer scanning a driver's QR code to make a payment"
          className="max-w-[200px]"
        />
      ),
    },
    {
      instruction: (
        <>
          Win ₦500 on referrals, and <Br /> enjoy free transfers on QR
        </>
      ),
      graphic: <WinOnReferrals className="max-w-[200px]" />,
    },
  ],
};

export const benefitsSection = {
  title: (
    <>
      Why drivers choose and
      <Br /> use Nomba app?
    </>
  ),
  benefits: [
    {
      tint: "bg-[#FFCC00]",
      icon: <RewardsIcon />,
      description:
        "In addition to the N1,000 bonus on each transaction, you'll also receive N500 for each successful referral while passengers get N500 cash-back.",
      title: "Rewards",
    },
    {
      icon: <SpeedIcon />,
      tint: "bg-[#33FF00]",
      description:
        "Enjoy super-fast transactions with Nomba QR payments with a 99.9% success rate.",
      title: "Speed",
    },
    {
      icon: <EaseOfUseIcon />,
      description:
        "The Nomba app is set up to help you start and complete transactions in just a few clicks.",
      title: "Easy to Use",
      tint: "bg-[#00FFF6]",
    },
  ],
};

export const paymentsSection = {
  title: (
    <>
      Nomba QR is fast, <Br /> stress-free, comes <Br /> with extra Cash!
    </>
  ),
  description:
    "Simply scan, pay, and enjoy the ease of seamless financial transactions with our QR payment feature. it is easy, fast and efficient, always.",
};

export const quoteSection = {
  title: (
    <>
      Effortless Payments, <Br /> Extra Cash!
    </>
  ),
  quoteText:
    "Nomba QR na big help for drivers like me. E dey give me peace of mind and make payments easy every time I hit the road.",
  quoteAuthor: "Saheed",
  quoteAuthorCompany: "Bolt/Uber Driver",
};

export const heroSection = {
  title: (
    <>
      Drive and{" "}
      <span className="!text-n-flavescent text-[#FFEB99]">
        make <Br on="desktop" /> up to 150k
      </span>{" "}
      with <Br on="desktop" /> Nomba QR
    </>
  ),
  description:
    "Interested in making more money on your trips? You can double your earnings everyday, when you accept payments.",
};

export const faqs = [
  {
    id: 1,
    header: "How much does the Nomba QR cost?",
    content:
      "Nomba QR is free for both parties when you accept payment from passengers. However there's a 0.5% charge capped at ₦100 for transactions made from your business account.",
  },
  {
    id: 2,
    header:
      "How do I send my customers a receipt when they pay with a QR code?",
    content:
      'After receiving a  notification of successful payment, simply tap on "share receipt" to select your preferred format and recipient.',
  },
  {
    id: 3,
    header: "How can I pay with Nomba QR?",
    content:
      'Log into your nomba app and select "pay via QR" to either scan a Nomba QR code or upload the receiver\'s Nomba QR.',
  },
  {
    id: 4,
    header: "Will my QR code expire?",
    content:
      "No, the QR code is unique to you and doesn't expire; you can use it as many times as you want.",
  },
  {
    id: 5,
    header: "Is the QR code safe?",
    content:
      "Yes, the QR code is a very safe and secure method of accepting and making payments on the go.",
  },
];
